var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8282 4.6875C14.3156 4.94659 10.0855 6.69861 6.71118 9.70642L11.7151 14.7101C12.8162 14.3192 14.0009 14.1055 15.2344 14.1055C16.4957 14.1055 17.7061 14.3286 18.8282 14.7366V4.6875Z",
    fill: "#F2B42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3774 17.9568L32.843 9.32068C29.5453 6.54877 25.488 4.9353 21.1719 4.6875V15.9406C21.9989 16.5057 22.7417 17.1854 23.3774 17.9568Z",
    fill: "#F2B42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.6526V25.8245H4.6875V24.6526C4.6875 20.9512 6.60431 17.6895 9.49707 15.8068L5.05402 11.3638C1.78711 15.0286 0 19.703 0 24.6526Z",
    fill: "#F2B42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7854 25.8245H40V24.6526C40 22.9485 39.7873 21.2773 39.3765 19.6685L33.7854 25.8245Z",
    fill: "#F2B42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 25.8638C18.7474 25.8638 17.5701 26.3514 16.6848 27.2368C14.8574 29.0645 14.8574 32.0381 16.6848 33.8658C17.5701 34.7511 18.7474 35.2388 19.9996 35.2388C21.2514 35.2388 22.4288 34.7511 23.3141 33.8658C25.1418 32.0381 25.1418 29.0645 23.3141 27.2368C22.4288 26.3514 21.2514 25.8638 19.9996 25.8638Z",
    fill: "#49B3B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0148 10.5122L20.7173 23.5566C22.324 23.7184 23.8142 24.4224 24.9714 25.5797C26.1567 26.765 26.8284 28.2719 26.989 29.8222L40.0001 15.496V10.5122H35.0148Z",
    fill: "#49B3B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCheck);
export default __webpack_public_path__ + "static/media/credit_check.5477ad5d.svg";
export { ForwardRef as ReactComponent };